import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ing_ferro',
  templateUrl: './ing_ferro.component.html',
  styleUrls: ['./ing_ferro.component.css']
})
export class Ing_ferroComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
